var _defs, _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellDec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_487",
    "data-name": "Group 487",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 247.591,
    height: 59.855,
    viewBox: "0 0 247.591 59.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    width: 247.591,
    height: 59.855,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 113.821,
    height: 40.59,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M39.844,16.15a14.524,14.524,0,0,1,1.681-4.39c2.36-4.059,6.369-6.837,9.748-6.8,2.661.045,4.552.707,5.621,1.968,1.438,1.693,1.3,4.365,1.085,5.806a5.144,5.144,0,0,1-2.651,3.672,11.922,11.922,0,0,1-6.195,1.424,30.578,30.578,0,0,1-9.29-1.684M51.106,0c-5.085.021-10.65,3.726-13.87,9.263a19.378,19.378,0,0,0-2.131,5.24c-9.332-3.1-16.239-3.812-22.121-2.31C4.775,14.29-.078,19.822,0,26.991a13.667,13.667,0,0,0,4.9,9.974A15.229,15.229,0,0,0,14.937,40.59a17.626,17.626,0,0,0,2.509-.181l-.7-4.911a10.685,10.685,0,0,1-8.615-2.3,8.656,8.656,0,0,1-3.166-6.264c-.053-4.8,3.318-8.42,9.249-9.935,5.077-1.294,11.619-.466,20.5,2.611a14.5,14.5,0,0,0,1.977,6.116c5.768,9.745,15.485,13.249,28.083,10.137,7.095-1.75,13.366-8.35,19.431-14.73,2.02-2.126,3.929-4.133,5.769-5.846,5.244-4.882,10.419-4.853,18.277-4.807,1.764.011,3.591.022,5.568-.025l-.112-4.96c-1.907.043-3.7.034-5.429.024-8.381-.048-15-.088-21.684,6.136-1.952,1.816-3.911,3.877-5.984,6.059C75.3,23.308,69.272,29.645,63.586,31.048c-10.554,2.6-17.956.039-22.625-7.847a9.51,9.51,0,0,1-.824-1.782c9.147,2.564,14.641,1.1,17.731-.746a10.075,10.075,0,0,0,5.019-7.213c.409-2.774.356-6.715-2.209-9.739C58.646,1.325,55.51.074,51.359,0L51.2,0Z",
    transform: "translate(0 -0.001)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 11.907,
    height: 10.414,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 10.033,
    height: 7.439,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M180.46,16.41a5.141,5.141,0,0,1-2.651-3.672c-.212-1.441-.352-4.113,1.085-5.806,1.068-1.26,2.959-1.923,5.621-1.968,3.379-.042,7.388,2.736,9.748,6.8a14.527,14.527,0,0,1,1.68,4.39,30.572,30.572,0,0,1-9.289,1.684,11.933,11.933,0,0,1-6.195-1.424M184.589,0l-.16,0c-4.15.071-7.287,1.322-9.319,3.717-2.565,3.024-2.617,6.966-2.209,9.739a10.072,10.072,0,0,0,5.019,7.213c3.09,1.843,8.584,3.31,17.731.746a9.51,9.51,0,0,1-.824,1.782c-4.67,7.887-12.07,10.452-22.625,7.847-5.687-1.4-11.71-7.74-17.024-13.331-2.074-2.181-4.033-4.242-5.985-6.059-6.684-6.224-13.3-6.185-21.684-6.136-1.731.01-3.522.019-5.428-.024l-.114,4.96c1.979.047,3.806.036,5.569.025,7.857-.046,13.033-.075,18.277,4.807,1.84,1.713,3.749,3.72,5.768,5.846,6.066,6.38,12.338,12.979,19.433,14.73,12.6,3.112,22.315-.393,28.083-10.137a14.485,14.485,0,0,0,1.977-6.116c8.884-3.078,15.425-3.906,20.5-2.611,5.931,1.515,9.3,5.135,9.249,9.935a8.658,8.658,0,0,1-3.167,6.264,10.681,10.681,0,0,1-8.614,2.3l-.7,4.911a17.626,17.626,0,0,0,2.509.181,15.234,15.234,0,0,0,10.038-3.625,13.674,13.674,0,0,0,4.9-9.974c.079-7.17-4.774-12.7-12.982-14.8-5.883-1.5-12.789-.794-22.122,2.31a19.379,19.379,0,0,0-2.131-5.24C195.332,3.726,189.766.022,184.682,0Z",
    transform: "translate(-121.967 -0.001)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    width: 11.908,
    height: 10.414,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 10.032,
    height: 7.439,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M116,6.764a2.458,2.458,0,0,0-3.63,0l-9.429-4.5c-1.588,1-2.065,1.3-3.653,2.3v8.426l3.653,2.3,8.763-4.183v5.651a2.481,2.481,0,1,0,4.962,0V11.113l8.763,4.183,3.653-2.3V4.566c-1.588-1-2.064-1.3-3.653-2.3Z",
    transform: "translate(-99.29 -2.262)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 10.338,
    height: 10.337,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(0 -0.001)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M14.937,40.59A15.231,15.231,0,0,1,4.9,36.965,13.675,13.675,0,0,1,0,26.99c-.079-7.17,4.774-12.7,12.984-14.8,5.882-1.5,12.789-.794,22.121,2.31a19.443,19.443,0,0,1,2.131-5.239C40.51,3.635,46.208-.1,51.359,0c4.15.071,7.287,1.323,9.319,3.718,2.565,3.023,2.618,6.964,2.21,9.739a10.075,10.075,0,0,1-5.02,7.213c-3.09,1.841-8.584,3.31-17.731.746a9.54,9.54,0,0,0,.825,1.781c4.669,7.888,12.07,10.452,22.624,7.848,5.687-1.4,11.71-7.741,17.025-13.331,2.074-2.183,4.032-4.242,5.984-6.06,6.684-6.223,13.3-6.184,21.685-6.136,1.73.01,3.521.02,5.428-.023l.113,4.96c-1.977.046-3.806.035-5.569.025-7.857-.046-13.033-.075-18.277,4.806-1.84,1.714-3.749,3.721-5.768,5.846C78.141,27.516,71.87,34.114,64.775,35.865c-12.6,3.112-22.314-.394-28.083-10.137a14.5,14.5,0,0,1-1.977-6.117c-8.883-3.078-15.425-3.906-20.5-2.61-5.931,1.515-9.3,5.135-9.249,9.933A8.652,8.652,0,0,0,8.13,33.2a10.678,10.678,0,0,0,8.614,2.3l.7,4.912a17.777,17.777,0,0,1-2.509.181M39.845,16.149c8.939,2.881,13.506,1.44,15.483.261a5.144,5.144,0,0,0,2.651-3.672c.212-1.442.353-4.114-1.085-5.807-1.068-1.259-2.959-1.922-5.621-1.968-3.379-.041-7.387,2.736-9.748,6.8a14.538,14.538,0,0,0-1.68,4.39",
    transform: "translate(0 0)",
    fill: "#f7ad4b"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M14.937,40.59A15.231,15.231,0,0,1,4.9,36.965,13.675,13.675,0,0,1,0,26.99c-.079-7.17,4.774-12.7,12.984-14.8,5.882-1.5,12.789-.794,22.121,2.31a19.443,19.443,0,0,1,2.131-5.239C40.51,3.635,46.208-.1,51.359,0c4.15.071,7.287,1.323,9.319,3.718,2.565,3.023,2.618,6.964,2.21,9.739a10.075,10.075,0,0,1-5.02,7.213c-3.09,1.841-8.584,3.31-17.731.746a9.54,9.54,0,0,0,.825,1.781c4.669,7.888,12.07,10.452,22.624,7.848,5.687-1.4,11.71-7.741,17.025-13.331,2.074-2.183,4.032-4.242,5.984-6.06,6.684-6.223,13.3-6.184,21.685-6.136,1.73.01,3.521.02,5.428-.023l.113,4.96c-1.977.046-3.806.035-5.569.025-7.857-.046-13.033-.075-18.277,4.806-1.84,1.714-3.749,3.721-5.768,5.846C78.141,27.516,71.87,34.114,64.775,35.865c-12.6,3.112-22.314-.394-28.083-10.137a14.5,14.5,0,0,1-1.977-6.117c-8.883-3.078-15.425-3.906-20.5-2.61-5.931,1.515-9.3,5.135-9.249,9.933A8.652,8.652,0,0,0,8.13,33.2a10.678,10.678,0,0,0,8.614,2.3l.7,4.912a17.777,17.777,0,0,1-2.509.181M39.845,16.149c8.939,2.881,13.506,1.44,15.483.261a5.144,5.144,0,0,0,2.651-3.672c.212-1.442.353-4.114-1.085-5.807-1.068-1.259-2.959-1.922-5.621-1.968-3.379-.041-7.387,2.736-9.748,6.8a14.538,14.538,0,0,0-1.68,4.39",
    transform: "translate(0 -0.001)",
    fill: "#f7ad4b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(31.369 12.763)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 7.731,
    height: 10.032,
    transform: "translate(0 7.365) rotate(-72.308)",
    fill: "#f7ad4b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    transform: "translate(106.905 5.277)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 10.032,
    height: 7.439,
    transform: "translate(0.001)",
    fill: "#f7ad4b"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M60.215,11.909c-.812,5.52-8.159,10.264-23.276,4.749-10.39-3.79-17.69-4.749-23.561-3.25C6.444,15.178,2.2,19.652,2.263,25.772c.065,5.794,5.871,12.24,14.613,10.991",
    transform: "translate(0.219 1.152)",
    fill: "none",
    stroke: "#f7ad4b",
    strokeMiterlimit: 10,
    strokeWidth: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M218.343,40.408l.7-4.911a10.681,10.681,0,0,0,8.614-2.3,8.654,8.654,0,0,0,3.167-6.264c.054-4.8-3.318-8.42-9.249-9.933-5.077-1.3-11.619-.467-20.5,2.61a14.509,14.509,0,0,1-1.977,6.117c-5.769,9.744-15.485,13.248-28.083,10.137-7.1-1.752-13.366-8.35-19.433-14.731-2.019-2.126-3.928-4.133-5.768-5.846-5.243-4.881-10.419-4.852-18.277-4.807-1.764.011-3.591.022-5.569-.024l.114-4.961c1.906.043,3.7.033,5.427.023,8.383-.046,15-.087,21.685,6.138,1.952,1.816,3.91,3.877,5.984,6.059,5.315,5.591,11.338,11.927,17.025,13.331,10.555,2.6,17.955.039,22.625-7.847a9.51,9.51,0,0,0,.824-1.782c-9.147,2.565-14.642,1.1-17.731-.746A10.075,10.075,0,0,1,172.9,13.46c-.409-2.775-.356-6.717,2.209-9.739,2.033-2.4,5.169-3.647,9.32-3.718,5.15-.1,10.848,3.631,14.122,9.262a19.372,19.372,0,0,1,2.131,5.239c9.332-3.1,16.24-3.812,22.121-2.31,8.209,2.095,13.063,7.627,12.984,14.8a13.67,13.67,0,0,1-4.9,9.975,15.228,15.228,0,0,1-10.038,3.625,17.6,17.6,0,0,1-2.508-.181m-24.081-28.65c-2.36-4.059-6.369-6.837-9.747-6.8-2.662.046-4.554.707-5.622,1.968-1.438,1.693-1.3,4.365-1.085,5.806a5.145,5.145,0,0,0,2.651,3.673c1.977,1.179,6.544,2.62,15.483-.261a14.5,14.5,0,0,0-1.68-4.39",
    transform: "translate(11.802 -0.001)",
    fill: "#ffb5a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M218.343,40.408l.7-4.911a10.681,10.681,0,0,0,8.614-2.3,8.654,8.654,0,0,0,3.167-6.264c.054-4.8-3.318-8.42-9.249-9.933-5.077-1.3-11.619-.467-20.5,2.61a14.509,14.509,0,0,1-1.977,6.117c-5.769,9.744-15.485,13.248-28.083,10.137-7.1-1.752-13.366-8.35-19.433-14.731-2.019-2.126-3.928-4.133-5.768-5.846-5.243-4.881-10.419-4.852-18.277-4.807-1.764.011-3.591.022-5.569-.024l.114-4.961c1.906.043,3.7.033,5.427.023,8.383-.046,15-.087,21.685,6.138,1.952,1.816,3.91,3.877,5.984,6.059,5.315,5.591,11.338,11.927,17.025,13.331,10.555,2.6,17.955.039,22.625-7.847a9.51,9.51,0,0,0,.824-1.782c-9.147,2.565-14.642,1.1-17.731-.746A10.075,10.075,0,0,1,172.9,13.46c-.409-2.775-.356-6.717,2.209-9.739,2.033-2.4,5.169-3.647,9.32-3.718,5.15-.1,10.848,3.631,14.122,9.262a19.372,19.372,0,0,1,2.131,5.239c9.332-3.1,16.24-3.812,22.121-2.31,8.209,2.095,13.063,7.627,12.984,14.8a13.67,13.67,0,0,1-4.9,9.975,15.228,15.228,0,0,1-10.038,3.625,17.6,17.6,0,0,1-2.508-.181m-24.081-28.65c-2.36-4.059-6.369-6.837-9.747-6.8-2.662.046-4.554.707-5.622,1.968-1.438,1.693-1.3,4.365-1.085,5.806a5.145,5.145,0,0,0,2.651,3.673c1.977,1.179,6.544,2.62,15.483-.261a14.5,14.5,0,0,0-1.68-4.39",
    transform: "translate(11.802 -0.001)",
    fill: "#f7ad4b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    transform: "translate(133.769 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(70.545 12.763)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    width: 10.032,
    height: 7.731,
    transform: "translate(0 3.049) rotate(-17.692)",
    fill: "#f7ad4b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256",
    transform: "translate(-3.117 5.277)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    width: 10.032,
    height: 7.439,
    fill: "#f7ad4b"
  }))))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M170.644,11.909c.812,5.52,8.159,10.264,23.276,4.749,10.39-3.79,17.69-4.749,23.561-3.25,6.935,1.77,11.184,6.244,11.116,12.364-.065,5.794-5.871,12.24-14.613,10.991",
    transform: "translate(16.513 1.152)",
    fill: "none",
    stroke: "#f7ad4b",
    strokeMiterlimit: 10,
    strokeWidth: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M125.432,2.262,114.187,7.63,102.942,2.262l-3.651,2.3v8.425l3.651,2.3,11.245-5.368L125.432,15.3l3.651-2.3V4.566l-3.651-2.3",
    transform: "translate(9.608 0.218)",
    fill: "#f7ad4b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(108.898 2.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(9.728 1.348)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M118.5,8.66a5.169,5.169,0,1,1-5.169-5.169A5.169,5.169,0,0,1,118.5,8.66",
    transform: "translate(-108.16 -3.492)",
    fill: "#f7ad4b"
  }))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M117.035,8.542a3.825,3.825,0,1,1-3.826-3.826,3.825,3.825,0,0,1,3.826,3.826",
    transform: "translate(10.585 0.456)",
    fill: "#f7ad4b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellDec);
export default __webpack_public_path__ + "static/media/bell-dec.785bfef26c35604bc8217c3a4b786cf9.svg";
export { ForwardRef as ReactComponent };